import axios from 'axios'
import { BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const CACHE_PREFIX = 'vexado_desconto_meia_';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarOpcaoDescontoMeiaPassagem (codigo) {
  const url = `${URL}/usuarios/empresa/${codigo}/opcao-desconto-meia-passagem`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      try { localStorage.setItem(`${CACHE_PREFIX}${codigo}`, JSON.stringify(response.data)); } catch (_) { // ignore
      }
      return dispatch({ type: BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        try {
          const cache = localStorage.getItem(`${CACHE_PREFIX}${codigo}`);
          if (cache) return dispatch({ type: BUSCAR_OPCAO_DESCONTO_MEIA_PASSAGEM, payload: { data: JSON.parse(cache) } });
        } catch (_) { // ignore
        }
      }
      throw erro;
    });
}
